import React from "react";
import Loader from "../../Loader/Index";
import SVGComponent from "../SVGComponent";
import ICONS from "../../../assets/Icons";

function figureOutRightIconColor(color) {
  // if the string "default" then leave colour unchanged
  if (color === "default") return undefined;
  // if colour is undefined then default to "text primary"
  if (!color) return "var(--text-primary)";
  // else use whatever colour that was passed
  return color;
}

/**
 *
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 *
 * @typedef {Object} Alert
 * @property {String} text Text to show
 * @property {String} [icon] Icon to show, defaults to alert icon
 * @property {String} [iconColor] Icon colour
 * @property {boolean} isLoading Is this alert loading
 * @property {OnClickEventHandler} onClick What to do on click
 * @property {boolean} isDisabled
 * @property {string} [iconRight] Right side icon, if left undefined then this is <Arrow right white>
 * @property {string | "default"} iconRightColor Right side icon colour,
 * if this is the string "default" then the colour is the colour of the image.
 * if this is undefined then the colour defaults to "var(--text-primary)"
 *
 * @param {Object} props
 * @param {Alert[]} props.alerts
 * @returns {JSX.Element}
 */
export default function CommonAlertsStrip({ alerts }) {
  return (
    <div
      className={`cas-alerts-section flex Qlg:flex-row flex-col ${alerts && alerts.length > 0 ? "p-padding-sm" : ""} justify-between gap-gap-sm`}
    >
      {alerts &&
        alerts?.length > 0 &&
        alerts.map((alert, i) => (
          <React.Fragment key={i}>
            {/* Alert */}
            <div
              onClick={alert.onClick ?? undefined}
              className={`flex flex-row justify-between w-full relative Qlg:w-[calc(var(--std-width)/${alerts.length})] z-z-index-base ${
                alert.onClick && !alert.isDisabled
                  ? "global-hover-white cursor-pointer"
                  : ""
              } rounded-border-radius-md
              ${alert.isDisabled ? "opacity-light-opacity cursor-not-allowed" : ""}`}
            >
              <div className="flex flex-row gap-gap-sm p-padding-sm items-center">
                {alert.isLoading ? (
                  <Loader height="var(--icon-md)" width="var(--icon-md)" />
                ) : (
                  <div className="flex-shrink-0">
                    <SVGComponent
                      url={alert.icon ?? ICONS.ALERT}
                      color={alert.iconColor}
                      width="var(--icon-md)"
                    />
                  </div>
                )}

                <div className="text-font-sm text-text-primary">
                  {alert.text}
                </div>
              </div>

              {/* {alert.onClick && (
                <div className="w-px bg-border_primary my-padding-sm" />
              )} */}

              {alert.onClick && (
                <div className="flex items-center pr-padding-sm">
                  <SVGComponent
                    color={figureOutRightIconColor(alert.iconRightColor)}
                    url={alert.iconRight ?? ICONS.ARROW_RIGHT_WHITE}
                    width="var(--icon-sm)"
                  />
                </div>
              )}
            </div>

            {/* Divider between alerts — placed inside flex gap */}
            {i !== alerts.length - 1 && <div className="w-px bg-primary-bg" />}
          </React.Fragment>
        ))}
    </div>
  );
}
